import { useState } from 'react';
import { handleChatPreview, resetProductPageQuestion, setIsShowButton } from 'redux/counterSlice';
import { useDispatch, useSelector } from 'react-redux';
import ChatBot1 from 'components/bot';
// import { chatBotWhite, shopmateWhite } from 'assets/icons';



interface ChartObject {
    chatHeight: boolean,
    isPreview: string,
    botName: string,
    tagline: string
    initialMessage: string,
    botLogo: string,
    headerColor: string,
    questionBackgroundColor: string,
    answerBackgroundColor: string,
    fontSize: number,
    avatarLogo: string
}

const ChatBox = ({ chatHeight, isPreview, botName, tagline, initialMessage, botLogo, headerColor, questionBackgroundColor, answerBackgroundColor, fontSize, avatarLogo }: ChartObject) => {
    const dispatch = useDispatch();
    const isShowButton = useSelector((state: any) => state.counter.isShowButton);
    // const [isShowButton, setIsShowButton] = useState<boolean>((isPreview === "isPreview") ? true : false);
    const [test, setTest] = useState<string>("");
    const [errored, setError] = useState<boolean>(false);
    const [followUP, setFollowUP] = useState<boolean>(false);
    const [typePassword, setTypePassword] = useState(false);
    const handleChatBot = () => {
        dispatch(handleChatPreview())
        dispatch(resetProductPageQuestion())
        dispatch(setIsShowButton())
    }


    return (
        <div className={`w-100 overflow-auto ${isPreview === "isPreview" && "preview-container"}`}>
            {isShowButton &&
                <ChatBot1
                    test={test}
                    setTest={setTest}
                    errored={errored}
                    setError={setError}
                    followUP={followUP}
                    setFollowUP={setFollowUP}
                    typePassword={typePassword}
                    setTypePassword={setTypePassword}
                    isPreview={isPreview}
                    chatHeight={true}
                    botName={botName}
                    tagline={tagline}
                    initialMessage={initialMessage}
                    botLogo={botLogo}
                    avatarLogo={avatarLogo}
                    headerColor={headerColor}
                    questionBackgroundColor={questionBackgroundColor}
                    answerBackgroundColor={answerBackgroundColor}
                    fontSize={fontSize}
                />
            }
            <div className={`chat-bot-section ${isPreview === "isPreview" && "preview-chat-bot-section"}`}>
                {/* {!isShowButton && (isPreview !== "isPreview") && <p>How may I help you today?</p>} */}
                {isPreview !== "isPreview" && isShowButton &&
                    <button type='button' className={`chat-bot-button ${isShowButton && "comments"} ${isPreview === "isPreview" && "preview-bot-button"}`} onClick={() => handleChatBot()}>
                        <i className="pi pi-times" style={{ fontSize: "22px" }}></i>
                        {/* {isShowButton ? <i className="pi pi-times" style={{ fontSize: "22px" }}></i>
                            : <i>
                                <img src={shopmateWhite} alt='chat-bot-icon' />
                            </i>} */}
                    </button>
                }
            </div>
        </div>
    )
}

export default ChatBox